/**
 * GST Utility Functions
 * Below ₹2499: 5% GST
 * ₹2500 and above: 12% GST
 * Note: GST is included in the display price
 */

// Get applicable GST rate based on price
export const getGSTRate = (price) => {
  return price < 2499 ? 0.05 : 0.12;
};

// Calculate GST amount from inclusive price
export const calculateGSTFromInclusivePrice = (inclusivePrice) => {
  const gstRate = getGSTRate(inclusivePrice);
  // Formula: GST = (Inclusive Price × GST Rate) / (1 + GST Rate)
  const gstAmount = (inclusivePrice * gstRate) / (1 + gstRate);
  return Math.round(gstAmount * 100) / 100; // Round to 2 decimal places
};

// Calculate base price from inclusive price
export const calculateBasePriceFromInclusive = (inclusivePrice) => {
  const gstRate = getGSTRate(inclusivePrice);
  // Formula: Base Price = Inclusive Price / (1 + GST Rate)
  const basePrice = inclusivePrice / (1 + gstRate);
  return Math.round(basePrice * 100) / 100; // Round to 2 decimal places
};

// Get GST breakdown for display
export const getGSTBreakdown = (inclusivePrice) => {
  const gstRate = getGSTRate(inclusivePrice);
  const gstAmount = calculateGSTFromInclusivePrice(inclusivePrice);
  const basePrice = calculateBasePriceFromInclusive(inclusivePrice);
  
  return {
    basePrice,
    gstRate: gstRate * 100, // Convert to percentage
    gstAmount,
    totalPrice: inclusivePrice,
    gstPercentageText: `${gstRate * 100}%`
  };
};

// Format GST info for display
export const formatGSTInfo = (inclusivePrice) => {
  const breakdown = getGSTBreakdown(inclusivePrice);
  return `(Incl. ${breakdown.gstPercentageText} GST: ₹${breakdown.gstAmount.toFixed(2)})`;
};

// Calculate GST for cart total
export const calculateCartGST = (cartSubtotal) => {
  return calculateGSTFromInclusivePrice(cartSubtotal);
};
